"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var database_1 = require("./model/database");
var ConnectionStatus = /** @class */ (function () {
    function ConnectionStatus() {
    }
    ConnectionStatus.open = 'open';
    return ConnectionStatus;
}());
exports.ConnectionStatus = ConnectionStatus;
var DatabaseApi = /** @class */ (function () {
    function DatabaseApi(api, apiConnector) {
        this._api = api;
        this._apiConnector = apiConnector;
    }
    DatabaseApi.prototype.dbApi = function () {
        return this._api.instance().db_api();
    };
    DatabaseApi.prototype.execute = function (operation) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._apiConnector.connection()
                .then(function () {
                _this.dbApi()
                    .exec(operation.name, operation.parameters)
                    .then(function (content) { return resolve(content); })
                    .catch(function (err) {
                    reject(_this.handleError(database_1.DatabaseError.database_execution_failed, err));
                });
            })
                .catch(function (err) {
                reject(_this.handleError(database_1.DatabaseError.api_connection_failed, err));
            });
        });
    };
    DatabaseApi.prototype.handleError = function (databaseErrorMessage, err) {
        var error = new Error(databaseErrorMessage);
        error.stack = err;
        return error;
    };
    return DatabaseApi;
}());
exports.DatabaseApi = DatabaseApi;
//# sourceMappingURL=database.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/api/database.js
// module id = 219
// module chunks = 0